import compose from '../../../../lib/compose';
import withFeatureFlag from '../../../../components/feature-flag/with-feature-flag';
import withRow from '../../../../components/grid/row/with-row';

const FEATURE_NAME = 'gallery';
const namespace = 'ui-pdp-gallery';

const getEnhance = withState =>
  compose(
    withFeatureFlag(`fixed.${FEATURE_NAME}`),
    withRow(FEATURE_NAME),
    withState,
  );

export { getEnhance, namespace, FEATURE_NAME };
